import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { Color } from 'csstype'

interface AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilMedicoesSectionProps {
  qtdMedicoesPesoAltura: number
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilMedicoesSection({
  qtdMedicoesPesoAltura,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilMedicoesSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='rulerFilled' color={iconColor} />
          <Text fontWeight='bold'>Medições (quantidade)</Text>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Registros de peso e altura simultâneos até 24 meses</Text>
          <Text>{qtdMedicoesPesoAltura ?? 0}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
